import React from 'react';

import Icon from 'components/Icon';
import { useOnline } from 'hooks/useOnline';

/**
 * A faixa "sem conexão", em qualquer tela, enquanto o aparelho não tem rede.
 *
 * <h2>Por que uma faixa, e não uma tela</h2>
 * Boa parte do que a pessoa faz não precisa de rede naquele instante: preencher o cadastro, ler o
 * que já carregou, escolher cidade (a lista é local). Cobrir o app, como faz a tela de manutenção,
 * tiraria tudo isso para avisar de uma coisa que ela provavelmente já sabe. A faixa diz o que está
 * acontecendo e sai do caminho -- e some sozinha quando a rede volta.
 *
 * <h2>Por que no rodapé</h2>
 * Cada página monta a própria NavBar (sticky, z-30); não há um lugar comum no topo onde uma faixa
 * caberia sem disputar com o header de cada tela. Embaixo é onde os apps do sistema põem o mesmo
 * aviso, e o inset da barra de gestos entra no padding para o texto não ficar debaixo dela.
 *
 * <h2>O que ela não faz</h2>
 * Não bloqueia botão nenhum e não substitui a mensagem de cada chamada que falhar: `navigator.onLine`
 * só sabe dizer "com certeza sem rede" (ver hooks/useOnline). Vale na web também -- uma SPA sem rede
 * se comporta igual dentro ou fora do app.
 */
const AvisoSemConexao = () => {
	const online = useOnline();

	if (online) return null;

	return (
		<div
			role="status"
			aria-live="polite"
			// z-[1000] como o CookieBanner; abaixo do ConsentimentoApp (1100), que é um diálogo e
			// precisa ficar por cima de tudo enquanto está aberto.
			//
			// Acima da barra de abas do app, quando ela está montada (snackbar sobre a navigation
			// bar, como no Material): a variável só existe com a barra, e fora disso vale 0. O inset
			// de baixo fica com quem encosta na borda: sem barra é esta faixa, com barra é a barra.
			className="fixed inset-x-0 bottom-[var(--altura-barra-inferior,0px)] z-[1000] bg-dark pb-[var(--safe-bottom-painel)] text-white shadow-lg"
		>
			<div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3 sm:px-6">
				<Icon name="wifi_off" className="h-5 w-5 flex-shrink-0" />
				<p className="text-sm">
					<span className="font-semibold">Você está sem conexão.</span>{' '}
					Verifique sua conexão para continuar.
				</p>
			</div>
		</div>
	);
};

export default AvisoSemConexao;
